import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Nav, NavItem } from '@feathr/components';
import { useLocalUrl, useRole } from '@feathr/extender/state';
import { getEventIdFromUrl } from '@feathr/extender/utils';

function EventSettingsNav(): JSX.Element {
  const localUrl = useLocalUrl();
  const eventId = getEventIdFromUrl();
  const { hasBilling } = useRole();
  const { t } = useTranslation();

  return (
    <Nav indented={true} label={'Project settings navigation'} type={'vertical'}>
      <NavItem
        data-command={'true'}
        data-command-description={t('Edit project information and details')}
        data-command-keywords={'info,information,project,details'}
        data-command-label={t('Project Information')}
        to={localUrl(`/projects/${eventId}/settings/info`)}
      >
        {t('Project Information')}
      </NavItem>
      {hasBilling && (
        <NavItem
          data-command={'true'}
          data-command-description={t('Manage project billing settings')}
          data-command-keywords={'billing,payment,settings'}
          data-command-label={t('Project Billing')}
          to={localUrl(`/projects/${eventId}/settings/billing`)}
        >
          {t('Billing')}
        </NavItem>
      )}
    </Nav>
  );
}

export default EventSettingsNav;
